import React, { useState } from "react";
import styled from "styled-components";
import Theme from "../Theme/Theme";
import CustomTextField from "../Utils/CustomTextField/CustomTextField";
import CustomButton from "../Utils/CustomButton/CustomButton";
import { IsMobile } from "../Context/Responsive/Responsive";
import LoginSurvice from "../Service/Login/LoginService.ts";
import { LoginPostModel } from "../Models/LoginModel/LoginPostModel.ts";
import { useNavigate } from "react-router";
import { CustomAlert } from "../Utils/CustomModal/CustomModal";
import { MainContext } from "../Context/MainContext/MainContext";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import loginUser from "../Redux/login/loginAction";

function LoginScreen() {
  const [username, setUsername] = useState("");
  const { setUserRole, userRoleValue } = MainContext();
  const navigator = useNavigate();
  const loadingData = useSelector((state) => state.loadingState);

  useEffect(() => {
    console.log(loadingData.loading);
  }, [loadingData.loading]);

  const dispatch = useDispatch();

  const usernameChange = (event) => {
    setUsername(event.target.value);
  };

  const [password, setPassword] = useState("");

  const passwordChange = (event) => {
    setPassword(event.target.value);
  };

  useEffect(() => {
    if (userRoleValue === "emp") {
      navigator("/admin-dashboard");
      CustomAlert.success(
        "با موفقیت انجام شد",
        "به سایت پیشخوان دانشگاه علوم و فنون خوش آمدید"
      );
    } else if (userRoleValue === "stu") {
      navigator("/dashboard");
      CustomAlert.success(
        "با موفقیت انجام شد",
        "به سایت پیشخوان دانشگاه علوم و فنون خوش آمدید"
      );
    } else {
      navigator("/login");
    }
  }, [userRoleValue]);

  const isMobile = IsMobile();
  const [showPass, changeShowPass] = useState(false);

  return (
    <Container>
      <ElementRightSide mobile={isMobile}>
        <Logo
          src={"/Assets/Images/logo.svg"}
          onClick={() => {
            window.open("https://www.ustmb.ac.ir/", "_blank");
          }}
        ></Logo>
        <RightSideTitle>ورود به حساب کاربری</RightSideTitle>

        <CustomTextField
          value={username}
          onChange={usernameChange}
          Icon={"/Assets/Images/personIcon.svg"}
          Label={"نام کاربری:"}
        ></CustomTextField>

        <CustomTextField
          value={password}
          onChange={passwordChange}
          Icon={"/Assets/Images/eyeIcon.svg"}
          Label={"کلمه عبور:"}
          type={showPass ? "text" : "password"}
          onClick={() => {
            changeShowPass(!showPass);
          }}
        ></CustomTextField>

        <ButtonContainer>
          <CustomButton
            Width={Theme.inputWidth}
            Label={"ورود"}
            OnClick={async () => {
              if (password?.length !== 0 && username?.length !== 0) {
                var temp = new LoginPostModel(
                  "",
                  username,
                  password,
                  "",
                  "",
                  ""
                );
                dispatch(loginUser(temp, navigator));
              } else {
                CustomAlert.error("هشدار", "لطفا اطلاعات را کامل وارد کنید");
              }
            }}
          ></CustomButton>
        </ButtonContainer>
      </ElementRightSide>
      {!isMobile ? (
        <ElementLeftSide>
          <LeftSidePoly src={"./Assets/Images/polygon.svg"}></LeftSidePoly>
          <LeftSideTitle>سامانه پیشخوان دانشجو</LeftSideTitle>
          <LeftSideText>
            دانشجویان محترم از این پس می توانند از طریق این پیشخوان جهت طرح
            سوالات خود از اعضا و کارمندان دانشگاه و دریافت پاسخ اقدام کنند.
          </LeftSideText>
          <LeftSideUnderText>
            دانشجویان از شماره دانشجویی خود برای نام کاربری استفاده کنند.
          </LeftSideUnderText>
          <LeftSideLogo src={"./Assets/Images/login.svg"}></LeftSideLogo>
        </ElementLeftSide>
      ) : null}
    </Container>
  );
}

export default LoginScreen;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  background-color: ${Theme.colorBackgroundBox};
  padding-block: 20px;
  padding-inline: 10px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
`;

const ElementRightSide = styled.div`
  width: ${(props) => (!props.mobile ? "60%" : "100%")};
  height: 100%;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: ${Theme.fontWeight};
`;

const ElementLeftSide = styled.div`
  position: relative;
  width: 35%;
  min-width: 457px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: ${Theme.borderRadius};
  background-color: ${Theme.colorBluePrimary};
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: ${Theme.fontWeight};
`;

const LeftSideTitle = styled.p`
  width: 100%;
  font-size: 32px;
  margin-top: 100px;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
`;

const LeftSideText = styled.p`
  width: 60%;
  height: max-content;
  margin-top: 50px;
  line-height: 30px;
  font-size: ${Theme.fontSize};
  text-overflow: clip;
  text-align: justify;
  color: #ffffff;
  font-weight: ${Theme.fontWeight};
`;

const LeftSideUnderText = styled.p`
  width: 60%;
  height: max-content;
  margin-top: 30px;
  line-height: 30px;
  font-size: ${Theme.fontSize};
  text-overflow: clip;
  text-align: center;
  color: #ffffff;
  font-weight: ${Theme.fontWeight};
`;

const LeftSidePoly = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;

const LeftSideLogo = styled.img`
  width: 70%;
  height: 60%;
  scale: 0.85;
  object-fit: contain;
`;

const RightSideTitle = styled.p`
  font-size: 24px;
  line-height: 41px;
  color: ${Theme.colorFontBlack};
  margin-bottom: 30px;
  font-weight: bold;
`;

const Logo = styled.img`
  position: absolute;
  top: 10px;
  right: 0;
  object-fit: contain;
  cursor: pointer;
`;

const ButtonContainer = styled.div`
  margin-top: 70px;
`;
